import { z } from '../zod';
import {
  TicketGroupEventIdInputSchema,
  TicketGroupIdInputSchema,
  TicketGroupPathParamsValidationSchema,
} from './params';

export const ArchiveTicketGroupParamsValidationSchema = TicketGroupPathParamsValidationSchema;

export const ArchiveTicketGroupInputValidationSchema = z.object({
  pageId: TicketGroupEventIdInputSchema,
  ticketGroupId: TicketGroupIdInputSchema,
});

export type ArchiveTicketGroupInput = z.infer<typeof ArchiveTicketGroupInputValidationSchema>;
